import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../FundingAccountPage/fundingAccount.css";

const rowsDemo = [
  { sym: "QQ", name: "Qoin" },
  { sym: "QG", name: "Qbitrium" },
  { sym: "1INCH", name: "1inch Network" },
  { sym: "ZZ", name: "ZyZag" },
  { sym: "XBST", name: "XBest" },
  { sym: "P", name: "PToken" },
  { sym: "ZUSD", name: "ZUSD" },
  { sym: "8A7", name: "8A7" },
  { sym: "AAVE", name: "Aave" },
  { sym: "ACH", name: "Alchemy Pay" },
  { sym: "ACN", name: "Acom" },
  { sym: "ACQ", name: "Acq4ive" },
  { sym: "ACS", name: "ACS" },
  { sym: "ACTSOL", name: "ActSol" },
];

export default function TradingAccountPage() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [searchActive, setSearchActive] = useState(false);
  const searchInputRef = useRef(null);
  const searchContainerRef = useRef(null);

  const toggleSearch = useCallback(() => {
    setSearchActive((v) => !v);
  }, []);

  useEffect(() => {
    if (!searchActive) return;
    const t = window.setTimeout(() => searchInputRef.current?.focus(), 320);
    return () => window.clearTimeout(t);
  }, [searchActive]);

  useEffect(() => {
    if (!searchActive) return;
    const onKey = (e) => {
      if (e.key === "Escape") setSearchActive(false);
    };
    const onClickOutside = (e) => {
      if (searchContainerRef.current && !searchContainerRef.current.contains(e.target)) {
        setSearchActive(false);
      }
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClickOutside);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, [searchActive]);
  const [hideSmall, setHideSmall] = useState(false);
  const [convertSmall, setConvertSmall] = useState(false);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rowsDemo;
    return rowsDemo.filter((r) => r.sym.toLowerCase().includes(q) || r.name.toLowerCase().includes(q));
  }, [search]);

  return (
    <div className="dashboard_right funding-account">
      <div className="funding-account__header">
        <div>
          <h1 className="funding-account__title">Spot Wallet</h1>
        </div>
        <div className="funding-account__header-actions">
          <button
            type="button"
            className="funding-account__pill funding-account__pill--primary"
            onClick={() => navigate("/asset_managemnet/deposit")}
          >
            Deposit
          </button>
          <button type="button" className="funding-account__pill" onClick={() => navigate("/asset_managemnet/deposit")}>
            Buy Crypto
          </button>
          <button type="button" className="funding-account__pill" onClick={() => navigate("/user_profile/wallet/trading")}>
            Transfer
          </button>
          <button type="button" className="funding-account__pill" onClick={() => navigate("/asset_managemnet/withdraw")}>
            Withdraw
          </button>
        </div>
      </div>

      <div className="funding-account__toprow">
        <div className="funding-account__totals">
          <div className="funding-account__totals-label">Total Assets</div>
          <div className="funding-account__totals-main">
            <span className="funding-account__totals-num">0</span>
            <span className="funding-account__totals-unit">BTC</span>
            <span className="funding-account__totals-sub">≈ 0 USD</span>
          </div>
        </div>
      </div>

      <div className="funding-account__filters rightsearch">
        <div
          ref={searchContainerRef}
          className={`searchBar custom-tabs ${searchActive ? "search_active" : ""}`}
          onClick={toggleSearch}
        >
          <i className="ri-search-2-line" aria-hidden="true" />
          <input
            ref={searchInputRef}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search"
            type="search"
            className="custom_search"
            aria-label="Search assets"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
        <label className="funding-account__check">
          <input type="checkbox" checked={hideSmall} onChange={(e) => setHideSmall(e.target.checked)} />
          Hide small balances
        </label>
        {/* <label className="funding-account__check smallkcs">
          <input type="checkbox" checked={convertSmall} onChange={(e) => setConvertSmall(e.target.checked)} />
          Convert small balances to KCS (0)
        </label> */}
      </div>

      <div className="funding-account__hintbar">
        <i className="ri-information-line" aria-hidden="true" />
        <span>
          To trade tokens, click Transfer to move the assets from your Funding Account to your Trading Account.
        </span>
      </div>

      <div className="funding-account__tablewrap">
        <table className="funding-account__table">
          <thead>
            <tr>
              <th>Coin</th>
              <th className="ta-r">Total Amount</th>
              <th className="ta-r">Available</th>
              <th className="ta-r">In Order</th>
              <th className="ta-r">Avg. Cost Price</th>
              <th className="ta-r">Action</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.sym}>
                <td data-label="Coin">
                  <div className="funding-account__coin">
                    <span className="funding-account__coin-dot" aria-hidden="true" />
                    <div>
                      <div className="funding-account__coin-sym">{r.sym}</div>
                      <div className="funding-account__coin-name">{r.name}</div>
                    </div>
                  </div>
                </td>
                <td className="ta-r" data-label="Total Amount">
                  <div className="funding-account__num">0</div>
                  <div className="funding-account__subnum">≈ 0 USD</div>
                </td>
                <td className="ta-r" data-label="Available">
                  <div className="funding-account__num">0</div>
                  <div className="funding-account__subnum">≈ 0 USD</div>
                </td>
                <td className="ta-r" data-label="In Order">
                  <div className="funding-account__num">0</div>
                  <div className="funding-account__subnum">≈ 0 USD</div>
                </td>
                <td className="ta-r" data-label="Avg. Cost Price">
                  <div className="funding-account__num">--</div>
                  <div className="funding-account__subnum">--</div>
                </td>
                <td className="ta-r" data-label="Action">
                  <div className="funding-account__actions">
                    <Link to="/convert" className="funding-account__action">
                      Convert
                    </Link>
                    <Link to="/trade" className="funding-account__action">
                      Trade
                    </Link>
                    <button type="button" className="funding-account__action funding-account__action--btn">
                      Transfer
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {hideSmall || convertSmall ? null : null}
    </div>
  );
}

